import { gql } from '@apollo/client';

export default gql`
  mutation updatePrrAttemptedCompensationRecords($recordsToUpdate: [InputUpdatePrrAttemptedCompensationRecords!]!) {
    updatePrrAttemptedCompensationRecords(recordsToUpdate: $recordsToUpdate)
  }
`;
